import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";

function useGetModelDetails(id) {

    const [modelDetails, setModelDetails] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        azureFetch("getMlModel", {modelId: id}).then((result) => {
            setModelDetails(result.data)
        }).catch((error) => {
            toast.error("Error fetching Model Details")
            console.log(error)
        }).finally(() => setLoading(false));
    }, [id]);

    return { modelDetails, loading }
}

export default useGetModelDetails;